import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import { IBaseResponse } from "../types/models";

export abstract class BaseResponse implements IBaseResponse {
  constructor(input?: DeepPartial<BaseResponse>) {
    if (input) {
      for (const [key, value] of Object.entries(input)) {
        (this as any)[key] = value;
      }
    }
  }
}
